import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { PK_COLORS } from '../PathkitLogo';

const faqs = [
  {
    q: 'What platforms does PathKit support?',
    a: (
      <>
        PathKit ships templates for Atlassian Jira Service Management, ServiceNow, Ivanti, a
        platform-neutral &ldquo;Generic&rdquo; template, and your own Custom templates. See{' '}
        <a href="#platforms" className="underline">
          Platforms
        </a>{' '}
        for tier coverage.
      </>
    ),
  },
  {
    q: 'How does PathKit use AI?',
    a: (
      <>
        AI-assisted features (suggestions, transcription, extraction) are powered by OpenAI,
        called server-side from PathKit. We never use your data to train models. Full detail in{' '}
        <a href="/ai-trust" className="underline">
          PathKit AI Data Use
        </a>
        .
      </>
    ),
  },
  {
    q: 'Where is my data stored?',
    a: (
      <>
        PathKit runs on Supabase with multi-tenant isolation: every consulting firm has its own
        subdomain and every client company is a separately-scoped record. See the{' '}
        <a href="/privacy" className="underline">
          Privacy Policy
        </a>{' '}
        for sub-processor and retention specifics.
      </>
    ),
  },
  {
    q: 'Do I need to migrate to use PathKit?',
    a: 'No. PathKit sits alongside Jira, ServiceNow, Ivanti, or whatever ticketing system your client uses. You design and scope in PathKit, then implement in the target platform.',
  },
  {
    q: 'Can I use my own domain?',
    a: 'Yes. Every firm gets a {firm}.pathkit.pro subdomain on every plan; Enterprise customers can host PathKit on their own custom domain.',
  },
  {
    q: 'How do I cancel?',
    a: 'Monthly plans cancel from inside Settings \u2192 Billing \u2014 no contracts, no calls. Annual plans follow the agreement you signed.',
  },
];

export function MarketingFAQ() {
  return (
    <section
      id="faq"
      className="py-20 md:py-24"
      style={{ backgroundColor: '#F8FAFC' }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2
            className="text-3xl md:text-4xl font-semibold tracking-tight"
            style={{ color: PK_COLORS.navy }}
          >
            Frequently asked questions
          </h2>
          <p className="mt-4 text-slate-600">
            Don&rsquo;t see what you&rsquo;re looking for?{' '}
            <a href="mailto:hello@pathkit.pro" className="underline hover:text-slate-900">
              Drop us a line
            </a>
            .
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-base">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
